import { parse, parser } from "mathjs";

console.log("math.js is loaded!!");

// Get all elements

const outputs = document.querySelectorAll("[j-calc-output]");

const firstAtt = outputs[0].getAttribute("j-calc-on-submit");

const allInputs = document.querySelectorAll("input");

const submitBtns = document.querySelectorAll("[j-calc-submit-btn]");

// Functions hey

function evaluateExpression(expression) {
  let inputNames = getExpressionVariables(expression);

  const exprParser = parser();

  inputNames.forEach((inputName) => {
    const inputEl =
      document.querySelector(`input[j-calc-input="${inputName}"]`) ||
      document.querySelector(`input[name="${inputName}"]`);

    if (inputEl) {
      const inputValue = getInputValue(inputEl);
      // getInputValue(inputEl);

      exprParser.set(inputName, inputValue);
    } else {
      console.error(
        `Input with the name ${inputName} or attribute "[j-calc-input=${inputName}]" not found on the page!`
      );
      return;
    }
  });

  let result = exprParser.evaluate(expression);

  return result;
}

function getExpressionVariables(expression) {
  let node = parse(expression);
  // Filter for SymbolNodes, which represent variables
  let variables = node.filter((node) => node.isSymbolNode);

  // Extract the names of the variables and return
  return variables.map((variable) => variable.name);
}

function getInputValue(inputElement) {
  const inputType = inputElement.type;

  let inputValue;

  switch (inputType) {
    case "radio":
      let selectedRadioValue =
        document.querySelector(
          `input[j-calc-input="${inputElement.name}"]:checked`
        )?.value ||
        document.querySelector(`input[name="${inputElement.name}"]:checked`)
          .value;

      inputValue = Number(selectedRadioValue) || 0;
      //console.log(inputValue)
      break;
    case "checkbox":
      inputValue = inputElement.checked
        ? Number(inputElement.getAttribute("j-calc-checkbox"))
        : 0;
      //console.log(inputValue)
      break;

    default:
      inputValue = inputElement.valueAsNumber || 0;

    //console.log(inputValue)
  }

  if (inputElement.getAttribute("j-calc-default") && !inputValue) {
    inputValue = Number(inputElement.getAttribute("j-calc-default"));
    //console.log(inputValue)
  }

  return inputValue;
}

allInputs.forEach((input) => {
  input.addEventListener("input", () => {
    outputs.forEach((output) => {
      if (!output.getAttribute("j-calc-submit-output")) {
        updateOutput(output);
      }
    });
  });
});

submitBtns.forEach((btn) => {
  btn.addEventListener("click", () => {
    const linkValue = btn.getAttribute("j-calc-submit-btn");
    const linkedOutput = document.querySelectorAll(
      `[j-calc-submit-output="${linkValue}"]`
    );

    //console.log(linkedOutput);

    if (linkedOutput.length === 0) {
      console.log("No matching output!");
      return;
    }

    linkedOutput.forEach((output) => {
      updateOutput(output);
    });
  });
});

function updateOutput(output) {
  let outputValue = evaluateExpression(output.getAttribute("j-calc-output"));

  const animateAttr = output.getAttribute("j-calc-animate");
  if (animateAttr !== null) {
    // Changed this line
    let duration = 500; // default duration
    let easeName = "linear"; // default ease

    if (animateAttr !== "" && animateAttr !== "true") {
      const [customDuration, customEase] = animateAttr
        .split(",")
        .map((s) => s.trim());
      if (customDuration) duration = parseInt(customDuration, 10) || duration;
      if (customEase) easeName = customEase;
    }

    animateNumber(output, outputValue, duration, easeName);
  } else {
    const outputType = output.tagName;

    outputValue = cleanOutput(output, outputValue) || outputValue;
    if (outputType === "INPUT") {
      output.value = outputValue;
    } else {
      output.innerText = outputValue;
      // animateNumber(output, outputValue, 500, (t) => 1 - Math.pow(1 - t, 2));
    }
  }
}

function cleanOutput(output, value) {
  const decimalPlaces = output.getAttribute("j-calc-dp");

  const roundTo = output.getAttribute("j-calc-round");

  if (roundTo) {
    return (outputValue = flexibleRound(value, roundTo));
  }

  if (decimalPlaces) {
    return value.toFixed(Number(decimalPlaces));
  }

  return value;
}

function roundToNearestX(num, x) {
  x = Number(x);
  return Math.round(num / x) * x;
}

function flexibleRound(num, unit) {
  // Determine if we're dealing with decimals or whole numbers
  if (unit >= 1) {
    // Rounding to nearest whole number unit (e.g., 10, 100)
    return Math.round(num / unit) * unit;
  } else {
    // Rounding to a decimal place (e.g., 0.1, 0.01)
    let decimalPlaces = Math.abs(Math.log10(unit));
    let scaleFactor = Math.pow(10, decimalPlaces);
    return Math.round(num * scaleFactor) / scaleFactor;
  }
}

function animateNumber(element, target, duration = 1000, easeName = "linear") {
  const start = parseFloat(element.textContent) || 0;
  const startTime = performance.now();
  const ease = animationEases[easeName] || eases.linear;

  function update(currentTime) {
    const elapsed = currentTime - startTime;
    const progress = Math.min(elapsed / duration, 1);
    const easedProgress = ease(progress);
    const current = start + (target - start) * easedProgress;

    element.textContent = cleanOutput(element, current) || current.toString();

    if (progress < 1) {
      requestAnimationFrame(update);
    }
  }

  requestAnimationFrame(update);
}

const animationEases = {
  linear: (t) => t,
  easeOut: (t) => 1 - Math.pow(1 - t, 2),
  easeIn: (t) => t * t,
  easeInOut: (t) => (t < 0.5 ? 2 * t * t : 1 - Math.pow(-2 * t + 2, 2) / 2),
  cubicEaseOut: (t) => 1 - Math.pow(1 - t, 3),
  cubicEaseIn: (t) => t * t * t,
  cubicEaseInOut: (t) =>
    t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2,
  elastic: (t) => {
    const c = (2 * Math.PI) / 3;
    return t === 0
      ? 0
      : t === 1
      ? 1
      : Math.pow(2, -10 * t) * Math.sin((t * 10 - 0.75) * c) + 1;
  },
  bounce: (t) => {
    const n1 = 7.5625;
    const d1 = 2.75;
    if (t < 1 / d1) return n1 * t * t;
    if (t < 2 / d1) return n1 * (t -= 1.5 / d1) * t + 0.75;
    if (t < 2.5 / d1) return n1 * (t -= 2.25 / d1) * t + 0.9375;
    return n1 * (t -= 2.625 / d1) * t + 0.984375;
  },
};